import { j as s } from "./jsx-runtime-B6kdoens.js";
import { UnlinkIcon as ue } from "lucide-react";
import { L as fe } from "./index-Yn8c3UWE.js";
import { C as me } from "./CategoryHeading-Bb9dqxD3.js";
import { Callout as de } from "./ui/Callout.js";
import { M as pe, P as ve, H as Ee } from "./Markdown-ievDDhFT.js";
import { b as xe, F as ye } from "./index-Czzd9rjU.js";
import { Z as $ } from "./invariant-Caa8-XvF.js";
import { h as Se } from "./router-lfyopgBI.js";
import N, { useContext as be } from "react";
import { u as he } from "./useExposedProps-CTPtylCV.js";
const L = ({
  children: t,
  className: a
}) => {
  if (process.env.NODE_ENV === "development")
    return /* @__PURE__ */ s.jsx(de, { type: "caution", title: "Developer hint", className: a, children: /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-2", children: [
      typeof t == "string" ? /* @__PURE__ */ s.jsx(pe, { content: t }) : /* @__PURE__ */ s.jsx("div", { children: t }),
      /* @__PURE__ */ s.jsx("small", { className: "italic", children: "Note: This hint is only shown in development mode." })
    ] }) });
}, _e = () => {
  const t = xe();
  return /* @__PURE__ */ s.jsxs("div", { className: ve + " h-full pt-[--padding-content-top]", children: [
    /* @__PURE__ */ s.jsx(me, { children: "404" }),
    /* @__PURE__ */ s.jsxs(Ee, { level: 1, className: "flex gap-3.5 items-center", children: [
      "Page not found",
      /* @__PURE__ */ s.jsx(ue, { size: 24 })
    ] }),
    /* @__PURE__ */ s.jsxs(L, { children: [
      "Start by adding a file at",
      " ",
      /* @__PURE__ */ s.jsxs("code", { children: [
        "{PROJECT_ROOT}",
        "/",
        t["*"],
        ".mdx"
      ] }),
      " ",
      "and add some content to make this error go away."
    ] }),
    /* @__PURE__ */ s.jsx("p", { children: "It seems that the page you are looking for does not exist or may have been moved. Please check the URL for any typos or use the navigation menu to find the correct page." }),
    /* @__PURE__ */ s.jsx(fe, { to: "/", children: "Go back home" })
  ] });
};
function Re({ error: t }) {
  const a = t instanceof Error ? t.message : "Something went wrong", i = t instanceof $ ? t.developerHint : void 0, l = t instanceof $ ? t.title : "Something went wrong", u = t instanceof Error ? t.stack : void 0, f = t instanceof Error ? t.cause : void 0;
  return /* @__PURE__ */ s.jsx("div", { className: "flex h-screen max-h-[calc(100vh-var(--header-height))] min-h-full items-center justify-center bg-primary-background px-4 py-16 lg:px-8", children: /* @__PURE__ */ s.jsxs("div", { className: "mx-auto max-w-[85%] sm:max-w-[50%]", children: [
    /* @__PURE__ */ s.jsx("h1", { className: "text-4xl font-bold tracking-tight text-h1-text sm:text-5xl", children: l }),
    /* @__PURE__ */ s.jsx("p", { className: "mt-5 text-h1-text", children: a }),
    i && /* @__PURE__ */ s.jsx(L, { className: "mb-4", children: i }),
    f instanceof Error ? /* @__PURE__ */ s.jsx("pre", { className: "mt-5 max-h-[400px] w-full overflow-scroll rounded-md border border-input-border bg-input-background p-3 text-property-name-text text-red-700", children: f.stack }) : u ? /* @__PURE__ */ s.jsx("pre", { className: "mt-5 max-h-[400px] w-full overflow-scroll rounded-md border border-input-border bg-input-background p-3 text-property-name-text text-red-700", children: u }) : null
  ] }) });
}
function ke() {
  const t = ye();
  return Se(t) && t.status === 404 ? /* @__PURE__ */ s.jsx(_e, {}) : /* @__PURE__ */ s.jsx(Re, { error: t });
}
var T = { exports: {} }, o = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j;
function Ce() {
  if (j) return o;
  j = 1;
  var t = Symbol.for("react.element"), a = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), d = Symbol.for("react.context"), _ = Symbol.for("react.server_context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), b;
  b = Symbol.for("react.module.reference");
  function c(e) {
    if (typeof e == "object" && e !== null) {
      var S = e.$$typeof;
      switch (S) {
        case t:
          switch (e = e.type, e) {
            case i:
            case u:
            case l:
            case v:
            case E:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case _:
                case d:
                case p:
                case y:
                case x:
                case f:
                  return e;
                default:
                  return S;
              }
          }
        case a:
          return S;
      }
    }
  }
  return o.ContextConsumer = d, o.ContextProvider = f, o.Element = t, o.ForwardRef = p, o.Fragment = i, o.Lazy = y, o.Memo = x, o.Portal = a, o.Profiler = u, o.StrictMode = l, o.Suspense = v, o.SuspenseList = E, o.isAsyncMode = function() {
    return !1;
  }, o.isConcurrentMode = function() {
    return !1;
  }, o.isContextConsumer = function(e) {
    return c(e) === d;
  }, o.isContextProvider = function(e) {
    return c(e) === f;
  }, o.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === t;
  }, o.isForwardRef = function(e) {
    return c(e) === p;
  }, o.isFragment = function(e) {
    return c(e) === i;
  }, o.isLazy = function(e) {
    return c(e) === y;
  }, o.isMemo = function(e) {
    return c(e) === x;
  }, o.isPortal = function(e) {
    return c(e) === a;
  }, o.isProfiler = function(e) {
    return c(e) === u;
  }, o.isStrictMode = function(e) {
    return c(e) === l;
  }, o.isSuspense = function(e) {
    return c(e) === v;
  }, o.isSuspenseList = function(e) {
    return c(e) === E;
  }, o.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === i || e === u || e === l || e === v || e === E || e === R || typeof e == "object" && e !== null && (e.$$typeof === y || e.$$typeof === x || e.$$typeof === f || e.$$typeof === d || e.$$typeof === p || e.$$typeof === b || e.getModuleId !== void 0);
  }, o.typeOf = c, o;
}
var n = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var A;
function Te() {
  return A || (A = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), a = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), d = Symbol.for("react.context"), _ = Symbol.for("react.server_context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), b = !1, c = !1, e = !1, S = !1, I = !1, P;
    P = Symbol.for("react.module.reference");
    function O(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === u || I || r === l || r === v || r === E || S || r === R || b || c || e || typeof r == "object" && r !== null && (r.$$typeof === y || r.$$typeof === x || r.$$typeof === f || r.$$typeof === d || r.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === P || r.getModuleId !== void 0));
    }
    function m(r) {
      if (typeof r == "object" && r !== null) {
        var C = r.$$typeof;
        switch (C) {
          case t:
            var h = r.type;
            switch (h) {
              case i:
              case u:
              case l:
              case v:
              case E:
                return h;
              default:
                var w = h && h.$$typeof;
                switch (w) {
                  case _:
                  case d:
                  case p:
                  case y:
                  case x:
                  case f:
                    return w;
                  default:
                    return C;
                }
            }
          case a:
            return C;
        }
      }
    }
    var k = d, Y = f, D = t, z = p, V = i, H = y, q = x, U = a, W = u, Z = l, G = v, X = E, g = !1, M = !1;
    function J(r) {
      return g || (g = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(r) {
      return M || (M = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function K(r) {
      return m(r) === d;
    }
    function Q(r) {
      return m(r) === f;
    }
    function ee(r) {
      return typeof r == "object" && r !== null && r.$$typeof === t;
    }
    function re(r) {
      return m(r) === p;
    }
    function te(r) {
      return m(r) === i;
    }
    function oe(r) {
      return m(r) === y;
    }
    function ne(r) {
      return m(r) === x;
    }
    function se(r) {
      return m(r) === a;
    }
    function ae(r) {
      return m(r) === u;
    }
    function ie(r) {
      return m(r) === l;
    }
    function ce(r) {
      return m(r) === v;
    }
    function le(r) {
      return m(r) === E;
    }
    n.ContextConsumer = k, n.ContextProvider = Y, n.Element = D, n.ForwardRef = z, n.Fragment = V, n.Lazy = H, n.Memo = q, n.Portal = U, n.Profiler = W, n.StrictMode = Z, n.Suspense = G, n.SuspenseList = X, n.isAsyncMode = J, n.isConcurrentMode = B, n.isContextConsumer = K, n.isContextProvider = Q, n.isElement = ee, n.isForwardRef = re, n.isFragment = te, n.isLazy = oe, n.isMemo = ne, n.isPortal = se, n.isProfiler = ae, n.isStrictMode = ie, n.isSuspense = ce, n.isSuspenseList = le, n.isValidElementType = O, n.typeOf = m;
  }()), n;
}
process.env.NODE_ENV === "production" ? T.exports = Ce() : T.exports = Te();
var Pe = T.exports;
const F = N.createContext({}), Ye = ({
  slotlets: t,
  children: a
}) => /* @__PURE__ */ s.jsx(F.Provider, { value: t, children: a }), De = ({ name: t }) => {
  const a = be(F), i = a == null ? void 0 : a[t], l = he();
  return Pe.isValidElementType(i) ? N.createElement(i, l) : i;
};
export {
  L as D,
  Re as E,
  ke as R,
  De as S,
  Ye as a
};
//# sourceMappingURL=SlotletProvider-DyomlzGx.js.map
